import { Box, useMediaQuery } from "@mui/material";

import OtpInput from "react-otp-input";

interface OTPProps {
  otp: string;
  setOtp: (otp: string) => void;
}

const OTP = ({ otp, setOtp }: OTPProps) => {
  const isSmallScreen = useMediaQuery("(max-width: 376px)");

  return (
    <Box>
      <OtpInput
        value={otp}
        onChange={setOtp}
        containerStyle={{
          display: "flex",
          justifyContent: "center",
          gap: isSmallScreen ? "5px" : "10px",
          direction: "ltr",
        }}
        numInputs={4}
        renderSeparator={<Box />}
        renderInput={(props) => (
          <input
            {...props}
            style={{
              fontSize: "24px",
              border: `1px solid #000`,
              backgroundColor: "white",
              borderRadius: "8px",
              width: isSmallScreen ? "50px" : "65px",
              height: isSmallScreen ? "50px" : "65px",
              marginInline: 5,
              textAlign: "center",
            }}
          />
        )}
      />
    </Box>
  );
};

export default OTP;
